import winnie from '../assets/winnie.jpg'
import nounours from '../assets/nounours.jpg'
import tigre from '../assets/tigre.jpg'
import bisounours from '../assets/bisounours.jpg'
import angrybird from '../assets/angrybird.jpg'
import toutou from '../assets/toutou.jpg'
import simba from '../assets/simba.jpg'
import sonic from '../assets/sonic.jpg'
import trotro from '../assets/trotro.jpg'
import penguin from '../assets/penguin.jpg'
import batman from '../assets/batman.jpg'
import spiderman from '../assets/spiderman.jpg'
import elsa from '../assets/elsa.jpg'
import rabbit from '../assets/rabbit.jpg'
import pikachu from '../assets/pikachu.jpg'
import mickey from '../assets/mickey.jpg'


// Nous créeons un tableau "plantList" qui contient plusieurs objets :
export const pelucheData = [
	{
		id: '1',
		name: 'winnie',
		category: 'disney',
		image: winnie,
		price: 15,
		stock: 'disponible',
		star: 4
	},
	{
		id: '2',
		name: 'nounours',
		category: 'classic',
		image: nounours,
		price: 16,
		stock: 'disponible',
		star: 3.5
	},

	{
		id: '3',
		name: 'tigre',
		category: 'classic',
		image: tigre,
		price: 9,
		stock: 'disponible',
		star: 3
	},
	{
		id: '4',
		name: 'sonic',
		category: 'superhero',
		image: sonic,
		price: 20,
		stock: 'en rupture',
		star: 4.5
	},
	{
		id: '5',
		name: 'angry bird',
		category: 'disney',
		image: angrybird,
		price: 12,
		stock: 'disponible',
		star: 3
	},

	{
		id: '6',
		name: 'trotro',
		category: 'classic',
		image: trotro,
		price: 7,
		stock: 'disponible',
		star: 3
	},
	{
		id: '7',
		name: 'toutou',
		category: 'classic',
		image: toutou,
		price: 7,
		stock: 'en rupture',
		star: 4
	},
	{
		id: '8',
		name: 'bisounours',
		category: 'classic',
		image: bisounours,
		price: 8,
		stock: 'disponible',
		star: 2
	},

	{
		id: '9',
		name: 'simba',
		category: 'disney',
		image: simba,
		price: 14,
		stock: 'disponible',
		star: 5
	},
	{
		id: '10',
		name: 'batman',
		category: 'superhero',
		image: batman,
		price: 19,
		stock: 'disponible',
		star: 5
	},
	{
		id: '11',
		name: 'penguin',
		category: 'classic',
		image: penguin,
		price: 8,
		stock: 'disponible',
		star: 2
	},
	{
		id: '12',
		name: 'spiderman',
		category: 'superhero',
		image: spiderman,
		price: 15,
		stock: 'disponible',
		star: 4
	},
	{
		id: '13',
		name: 'elsa',
		category: 'disney',
		image: elsa,
		price: 16,
		stock: 'en rupture',
		star: 5
	},
	{
		id: '14',
		name: 'lapin',
		category: 'classic',
		image: rabbit,
		price: 6,
		stock: 'disponible',
		star: 3
	},
	{
		id: '15',
		name: 'pikachu',
		category: 'superhero',
		image: pikachu,
		price: 13,
		stock: 'disponible',
		star: 4
	},
	{
		id: '16',
		name: 'mickey',
		category: 'disney',
		image: mickey,
		price: 9,
		stock: 'disponible',
		star: 4
	}
]